// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.btn[data-v-2ff2168c] {\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  /*transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;*/\n}\n.btn-outline-dark[data-v-2ff2168c] {\n  border: 1px solid #39434e;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
